<template>
  <!--教学计划-->
  <div>
    <el-form
      :model="ruleForm"
      ref="ruleForm"
      size="small"
      :rules="rules"
      label-width="100px"
      class="form"
    >
      <el-form-item label="计划标题：" prop="planTitle">
        <el-input
          placeholder="请输入标题"
          v-model="ruleForm.planTitle"
          required
          maxlength="50"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="计划内容："
        prop="planContent"
        required
        :show-message="showError"
      >
        <!--        <rich-text
          :detail.sync="ruleForm.planContent"
          @change-con="changeCon"
          uploadUrl="class/attachment"
        ></rich-text>-->
        <weditor
          :detail.sync="ruleForm.planContent"
          uploadUrl="class/attachment"
          @change-con="changeCon"
        />
      </el-form-item>
      <el-form-item label="附件：">
        <upload
          ref="upload"
          :limit="5"
          :path="'class/attachment'"
          v-model="ruleForm.attachmentList"
        />
      </el-form-item>
      <el-form-item style="text-align: center;">
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getTeachingPlanInfo, teachingPlanSave } from "@/api/teachingPlan";
// import richText from '@/components/RichText/index'
import weditor from "@/components/weditor/index";
import Upload from "@/components/upload/index";
export default {
  components: {
    //richText,
    Upload,
    weditor
  },
  data() {
    return {
      classId: "",
      showError: false,
      ruleForm: {
        classId: "",
        uuid: "",
        planTitle: "",
        planContent: "",
        attachmentList: []
      },
      rules: {
        planTitle: [
          { required: true, message: "请输入计划标题", trigger: "blur" }
        ],
        planContent: [
          {
            required: true,
            message: "请输入计划内容"
          }
        ]
      }
    };
  },
  methods: {
    changeCon(data) {
      this.ruleForm.planContent = data;
      if (!this.ruleForm.planContent) {
        this.showError = true;
      } else {
        this.showError = false;
      }
    },
    onSubmit() {
      this.$refs["ruleForm"].validate(valid => {
        if (!this.ruleForm.planContent) {
          this.showError = true;
        }
        if (valid) {
          this.$confirm(`确认提交吗？`, "系统提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.ruleForm.attachment = JSON.stringify(
              this.ruleForm.attachmentList
            );
            teachingPlanSave(this.ruleForm).then(res => {
              if (!res || res.code != 0) return;
              this.$router.back();
              this.$refs["ruleForm"].resetFields();
            });
          });
        }
      });
    },
    getInfo() {
      getTeachingPlanInfo(this.ruleForm.classId).then(res => {
        if (!res || res.code != 0 || !res.data) return;
        this.ruleForm.planTitle = res.data.planTitle || "";
        this.ruleForm.planContent = res.data.planContent || "";
        this.ruleForm.attachmentList = res.data.attachment
          ? JSON.parse(res.data.attachment)
          : [];
        this.ruleForm.uuid = res.data.uuid || "";
      });
    }
  },
  created() {
    this.ruleForm.classId = this.$route.query.id;
    this.getInfo();
  }
};
</script>
